export const RESOURCE_LIST_CONSTANT = {
  MENU_RESOURCE_LIST: 'Resource List',
  PLACEHOLDER_SEARCH: 'Search Resource Name and Resource ID',
  BUTTON_RESOURCE_LIST_ADD: 'Add Resources',
  NOTIFICATION_ERROR_TITLE: 'Error!',
  NOTIFICATION_ERROR_CONTENT_GET_RESOURCELIST: 'Failed Get List',
  NOTIFICATION_ERROR_CONTENT_DETAIL_GET_RESOURCELIST : 'Get Resource List Failed',

  TABLE_LOGO_COLUMN: 'Logo',
  TABLE_RESOURCE_NAME_COLUMN: 'Resource Name',
  TABLE_RESOURCE_ID_COLUMN: 'Resource ID',
  TABLE_DESCRIPTION_COLUMN: 'Description',
  TABLE_ACTION_COLUMN: 'Action',

  MODAL_CANCEL_TITLE: 'Confirm Exit?',
  MODAL_CANCEL_CONTENT: 'Data not Saved, Are you sure you want to exit?',
  MODAL_CANCEL_OK_TEXT: 'Yes, Confirm',
  MODAL_CANCEL_NO_TEXT: 'Cancel',

  VALIDATION_RESOURCE_ID_REQUIRED: "Please enter Resource ID contains lowercase letters, and numbers in the format: a-z,0-9,+$ (example: nex0091)",
  VALIDATION_RESOURCE_NAME_REQUIRED: "Please enter Resource Name, check again",
  VALIDATION_LOGO_REQUIRED: "Please enter an image in PNG, JPG or Jpeg format with maximum size of 2 Mb, check again",

  PLACEHOLDER_RESOURCE_ID: "Please Input Resource ID",
  PLACEHOLDER_RESOURCE_NAME: "Please Input Resource Name",
  PLACEHOLDER_DESCRIPTION: "Please Input Description",
  PLACEHOLDER_UPLOAD_LOGO_CLICK: "Click to upload",
  PLACEHOLDER_UPLOAD_LOGO_DRAGDROP: " or drag and drop PNG, JPG or Jpeg (max 2Mb)",

  MODAL_SUCCESS_TITLE_ADD_RESOURCES: 'Success',
  MODAL_SUCCESS_CONTENT_ADD_RESOURCES: 'The resource has been added',
  MODAL_SUCCESS_OK_BUTTON_ADD_RESOURCES: "Back to Resource List",

  MODAL_FAILED_TITLE_ADD_RESOURCES: 'Failed',
  MODAL_FAILED_CONTENT_ADD_RESOURCES: 'The resource failed to add',
  MODAL_FAILED_OK_BUTTON_ADD_RESOURCES: "Try Again",

  TITLE_RESOURCE_LIST_EDIT: 'Edit Data Resource List',

  MODAL_SUCCESS_CONTENT_EDIT_RESOURCES: 'Edit Resource Data saved successfully',
  MODAL_FAILED_CONTENT_EDIT_RESOURCES: 'Edit Resource Data failed to saved',

  TITLE_RESOURCE_LIST_DETAIL: 'Detail Data Resource List',
  TITLE_RESOURCE_LIST_DELETE: 'Delete Data Resource List',

  MODAL_DELETE_TITLE: 'Delete Data Resource?',
  MODAL_DELETE_CONTENT: 'Are you sure you want to Delete this Resource ?',
  MODAL_DELETE_OK_TEXT: 'Yes, Delete',
  MODAL_DELETE_NO_TEXT: 'Cancel',

  MODAL_SUCCESS_CONTENT_DELETE_RESOURCES: 'Resource Data Deleted Successfully',
  MODAL_FAILED_CONTENT_DELETE_RESOURCES: 'Resource Data Failed to Delete',

}